"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConsultingRequest = void 0;
var React = _interopRequireWildcard(require("react"));
var _context = require("../context");
var _consultingRequest = require("../services/consultingRequest");
var _tracking = require("../utils/tracking");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useConsultingRequest = _ref => {
  let {
    defaultPhoneNumber,
    regionId
  } = _ref;
  const {
    httpApi,
    logger
  } = React.useContext(_context.NewbuildingKpnBannerContext);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [phone, setPhone] = React.useState(defaultPhoneNumber);
  const onPhoneChange = React.useCallback(value => {
    setPhone(value);
    setError(false);
  }, []);
  const callbackHandler = React.useCallback(async _ref2 => {
    let {
      regionId,
      phone
    } = _ref2;
    const parameters = {
      phone: `+7${phone}`,
      regionId,
      cianRentRefocus: {
        cianRentRefocus: true
      }
    };
    setLoading(true);
    try {
      await (0, _consultingRequest.createConsultingRequest)({
        httpApi,
        parameters
      });
      setSuccess(true);
    } catch (error) {
      logger.error(error);
    }
    setLoading(false);
    (0, _tracking.trackLinkClick)();
  }, [httpApi, logger]);
  const onSubmit = React.useCallback(async () => {
    if (phone.length < 10) {
      setError(true);
      return;
    }
    await callbackHandler({
      phone,
      regionId
    });
  }, [callbackHandler, phone, regionId]);
  return React.useMemo(() => ({
    loading,
    success,
    onSubmit,
    error,
    phone,
    onPhoneChange
  }), [onSubmit, onPhoneChange, loading, success, error, phone]);
};
exports.useConsultingRequest = useConsultingRequest;